import React, { useState, useEffect } from "react";
import { api } from "../../services";

export default function ModalIframe({ reportToken }) {
    const [blobObject, setBlobObject] = useState(null);

    useEffect(() => {
        if (!reportToken) return;
        const options = {
            method: 'GET',
            url: `/v2/report/${reportToken}/html?internal_access=true`,
            responseType: "blob"
        };

        api.request(options)
            .then(({ data }) => {
                var blob = new Blob([data], { type: "text/html" })
                const obj = URL.createObjectURL(blob)
                setBlobObject(obj)
            })
            .catch(e => console.error("Error", e))
    }, [reportToken]);

    if (!blobObject) return <></>;

    return (
        <iframe width="100%" height="100%" src={blobObject} />
    )
}